import type { BridgeMcpToolCallResult } from '../../../bridge-mcp-tool-types.js';

export function mcpTextResult(text: string, isError = false): BridgeMcpToolCallResult {
  return { content: [{ type: 'text', text }], ...(isError ? { isError: true } : {}) };
}
